import request from '@/utils/request'

export const login = (data) => {
  return request.post('/api/v1/auth/login', data)
}

export const getUserInfo = () => {
  return request.get('/api/v1/auth/info')
}

export const logout = () => {
  return request.post('/api/v1/auth/logout')
}
